import { DataLayerSearch, DataLayerSearchFilter, Job, UserObject } from "./interfaces";
import { Params } from "./search-params";
import { getUserObject } from "./session/sessionmain";

const dataLayer = (<any>window)['dataLayer'];

export function logEvent(item: string, event: string, ignoreLogAttribute: boolean, dataElement: HTMLElement, additionalUrlInfo: string | null = null) {
    if (ignoreLogAttribute || dataElement.getAttribute("data-ga-log")) {
        const ga = (<any>window).ga
        let path_name = window.location.pathname;
        if (additionalUrlInfo) {
            path_name = path_name + additionalUrlInfo;
        }
        let label = "USAJOBS_" + path_name + window.location.search + "_" + dataElement.getAttribute("data-ga-label");
        dataElement.setAttribute("data-ga-log", "false");
        if (ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                ga(trackerName + '.send', 'event', item, event, label);
            }
        }
    } else {
        dataElement.setAttribute("data-ga-log", "true");
    }
}

export function simpleLogEvent(item: string, event: string, label: string) {
    const ga = (<any>window).ga;
    if (!ga) { return; }

    if (ga && ga.create) {
        var trackers = ga.getAll();
        if (trackers && trackers.length > 0) {
            var trackerName = trackers[0].get('name');
            var eventLabel = window.location.hostname + "_" + label;
            ga(trackerName + '.send', 'event', "USAJOBS_" + item, event, eventLabel);
        }
    }
}

function getDataLayerObjectForSearch(urlObject: Params, userObject: UserObject, event: string, setFilters: boolean, isAutocomplete: boolean): DataLayerSearch {
    const SearchTermParams = ['k', 'soc', 'jt', 'j', 'a', 'Keyword', 'IsAuthenticated', 'UniqueSearchID', 'Page', 'ResultsPerPage'];
    let dataLayerObject: DataLayerSearch = {
        "event": event,
        "searchId": userObject.UniqueSearch.Id,
        "authenticated": userObject.IsAuthenticated,
        "search_term": urlObject['Keyword'] ?? "",
        "filters": { "filterId": userObject.UniqueSearch.filters["filterId"] ?? crypto.randomUUID() },
        "total_results": urlObject.TotalResults,
        "autocomplete": isAutocomplete
    };
    for (let key in urlObject) {
        if (SearchTermParams.indexOf(key) > -1 || key === 'TotalResults') {
            continue;
        }
        let value = urlObject[key];
        if (value !== undefined && value !== null && ((Array.isArray(value) && value.length > 0) || value.toString().length > 0)) {
            dataLayerObject.filters[key] = value;
        }
    }
    if (setFilters === true) {
        userObject.UniqueSearch["filters"] = dataLayerObject.filters;
        userObject.UniqueSearch.filters["filterId"] = crypto.randomUUID();
        dataLayerObject.filters.filterId = userObject.UniqueSearch.filters.filterId;
        sessionStorage.setItem("userObject", JSON.stringify(userObject));
    }
    return dataLayerObject;
}

export function logSearch(urlObject: Params, isAutocomplete: boolean) {
    if (dataLayer) {
        dataLayer.push(getDataLayerObjectForSearch(urlObject, getUserObject(), "view_search_results", true, isAutocomplete));
        console.debug(dataLayer);
    }
}

export function logSearchFilterInteraction(urlObject: Params, isAutocomplete: boolean) {
    if (dataLayer) {
        const userObject = getUserObject();
        let filterId = userObject.UniqueSearch.filters.filterId;
        const dataLayerSearchFilters: DataLayerSearchFilter = {
            ...getDataLayerObjectForSearch(urlObject, userObject, "filter_interaction", false, isAutocomplete),
            filter_added: false,
            filter_removed: false,
            filters_changed: []
        };

        for (const prop in userObject.UniqueSearch.filters) {
            if (prop === 'filterId' || prop === 'TotalResults') {
                continue;
            }
            const dataLayerFilter = dataLayerSearchFilters.filters[prop];
            const uoFilter = userObject.UniqueSearch.filters[prop];
            if (dataLayerFilter === undefined || (Array.isArray(dataLayerFilter) && dataLayerFilter.length < uoFilter.length)) {
                dataLayerSearchFilters.filter_removed = true;
                if (dataLayerSearchFilters.filters_changed?.indexOf(prop) === -1) {
                    dataLayerSearchFilters.filters_changed.push(prop);
                    dataLayerSearchFilters.filters[prop] = Array.isArray(dataLayerFilter) ? dataLayerFilter : undefined;
                }
            }
            else if (dataLayerFilter != undefined && !Array.isArray(dataLayerFilter) && uoFilter != dataLayerFilter && dataLayerSearchFilters.filters_changed?.indexOf(prop) === -1) {
                dataLayerSearchFilters.filters_changed.push(prop);
            }
        }

        for (const prop in dataLayerSearchFilters.filters) {
            if (prop === 'filterId' || prop === 'TotalResults') {
                continue;
            }
            const dataLayerFilter = dataLayerSearchFilters.filters[prop];
            const uoFilter = userObject.UniqueSearch.filters[prop];
            if (uoFilter === undefined || (Array.isArray(uoFilter) && dataLayerFilter?.length > uoFilter.length)) {
                dataLayerSearchFilters.filter_added = true;
                if (dataLayerSearchFilters.filters_changed?.indexOf(prop) === -1) {
                    dataLayerSearchFilters.filters_changed.push(prop);
                }
            }
            else if (uoFilter != undefined && !Array.isArray(uoFilter) && uoFilter != dataLayerFilter && dataLayerSearchFilters.filters_changed?.indexOf(prop) === -1) {
                dataLayerSearchFilters.filters_changed.push(prop);
            }
        }

        if (dataLayerSearchFilters.filters_changed.length > 0) {
            filterId = crypto.randomUUID();
            userObject.UniqueSearch.filters = dataLayerSearchFilters.filters;
            userObject.UniqueSearch.filters.filterId = filterId;
            dataLayerSearchFilters.filters.filterId = filterId;
            sessionStorage.setItem('userObject', JSON.stringify(userObject));
            dataLayer.push(dataLayerSearchFilters);
            console.debug(dataLayer);
        }
    }
}

export function logSearchConversion(userObject: UserObject, event: string) {
    if (dataLayer) {
        const dataLayerObject = {
            event: event,
            searchId: userObject.UniqueSearch.Id,
            filterId: userObject.UniqueSearch.filters.filterId,
            conversionId: userObject.SearchResults.ConversionId,
            selectedDocumentId: userObject.SearchResults.SelectedDocumentId,
            selectedDocumentPage: userObject.SearchResults.Results.PageSets[0].Page,
            selectedDocumentRank: userObject.SearchResults.Results.Items.indexOf(userObject.SearchResults.SelectedDocumentId) + 1
        }
        dataLayer.push(dataLayerObject);
        console.debug(dataLayer);
    }
}

export function logSaveJob(joa: Job, isSaving: boolean) {
    if (dataLayer) {
        const dataLayerObject = {
            event: 'save_job_click',
            searchId: getUserObject()?.UniqueSearch?.Id,
            saved: isSaving,
            agency: joa.Agency,
            department: joa.Department,
            title: joa.Title,
            series: joa.JobCategoryCode?.map(x => x.Code).join("|"),
            office: joa.SubAgency,
            grade: `${joa.JobGrade}${joa.LowGrade}-${joa.HighGrade}`
        }
        dataLayer.push(dataLayerObject);
        console.debug('dataLayer', dataLayer);
    }
}
